const features = {
  'features-breadcrumbs-daily': 'Daily',
  'features-breadcrumbs-editors-choice': 'Editor\'s choice',
  'features-breadcrumbs-external-promo': 'External promo',
  'features-table-featured-column': 'Show in featured',
  'features-create-title': 'Create data',
  'features-update-title': 'Edit data',
  'features-form-collapse-title-targets': 'Targets',
  'features-form-image-id-label': 'Image ID',
  'features-form-show-featured-label': 'Show in featured',
  'features-utc': 'UTC+0',
  'features-title-info': 'In case when this field is empty it will be filled automatically',
  'features-title-use-automatic-generation-info': 'Title generates automatically',
  'features-show-in-features-info': 'Display feature in app "features section" (Slider at the top of the screen)',
  'features-details-unpublish': 'Unpublish from HC',
  'features-edit-images-to-attach': 'Images ready for use',
  'features-edit-images-to-attach-confirm-message': 'Are you sure you want to use this image? All unsaved changes will be removed.',
  'features-edit-images-to-attach-published-daily-cancel': 'You cannot change the image when the daily is published. To change the image, please unpublish the daily first.',
  'features-edit-images-to-attach-success': 'Image attached successfully',
  'features-edit-images-to-attach-failed': 'Image attach failed',
  'features-unpublish-failed': 'Failed to unpublish',
  'features-edit-publish-to-hc': 'Publish changes to HappyColor',
  'features-not-featured-tag': 'Not in featured',
  'features-disabled-template-text-error': 'Current template is inactive. To enable publishing please enable template status first.',
  'features-publish-notification-note': 'Publish is not allowed in case when there is no any attached images.',
  'features-daily-change-released-at-warning-note': 'You cannot update released at field, daily is in production for all or part of the world.',
  'features-unpublish-used-notification': 'Unable to unpublish a feature attached to an event',
};

export default features;
